<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="computedFilter"
        module="basic"
        url="snSerialNos"
        @addOrEdit="addEditHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="类型">
              <el-select v-model="filter.serialNoType" clearable placeholder="请选择类型">
                <el-option label="产品条码" :value="10"/>
                <el-option label="外包装条码" :value="20"/>
              </el-select>
            </el-form-item>
            <el-form-item label="序列号">
              <el-input v-model.trim="filter.serialNo" placeholder="请输入序列号" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model.trim="filter.orders" placeholder="请输入订单号" clearable/>
            </el-form-item>
            <el-form-item label="发货单号">
              <el-input v-model.trim="filter.deliverBillNo" placeholder="请输入发货单号" clearable/>
            </el-form-item>
            <el-form-item label="创建时间">
              <el-date-picker
                  v-model="filter.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <sn-serial-manage-edit ref="snSerialManageEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import SnSerialManageEdit from "./SnSerialManageEdit.vue";

  export default {
    name: "SnSerialManageList",
    components: { ViewTable, SnSerialManageEdit },
    data() {
      return {
        limits: {
          // 编辑权限：使用页面访问权限（authIndex 770），能访问本页面的用户即可看到编辑按钮
          editAuth: this.$auth(146),
        },
        filter: {
          serialNoType: "",
          serialNo: "",
          materialNo: "",
          orders: "",
          deliverBillNo: "",
          createTime: [],
        },
        columnsProperty: [
          {
            key: "serialNo",
            width: 200,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.snSerialManageEdit.open(params.row, true);
                    },
                  },
                },
                params.row.serialNo
              );
            },
          },
          {
            key: "materialNo",
            width: 130,
            align: "center",
          },
          {
            key: "materialName",
            minWidth: 200,
          },
          {
            key: "specification",
            width: 150,
            align: "center",
          },
          {
            key: "warehouseName",
            width: 150,
            align: "center",
          },
          {
            key: "locationName",
            width: 150,
            align: "center",
          },
          {
            key: "status",
            width: 100,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    computed: {
      computedFilter() {
        const { createTime, ...rest } = this.filter;
        if (createTime && createTime.length === 2) {
          return {
            ...rest,
            startTime: createTime[0],
            endTime: createTime[1],
          };
        }
        return { ...rest, startTime: "", endTime: "" };
      },
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        this.$refs.snSerialManageEdit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "snSerialNos", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
